import { apiSlice } from '@/api'

export const authorizationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/api/v2/login',
        method: 'POST',
        // processor пишет источник входа в историю входов
        headers: { 'X-Client': 'adminka' },
        body: credentials
      }),
      extraOptions: { maxRetries: 1 }
    })
  })
})

export const { useLoginMutation } = authorizationApi
